export default "<app-dashboard-principal></app-dashboard-principal>\n<router-outlet></router-outlet>"